import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "container p-0" };
const _hoisted_2 = { class: "row ms-2 me-2" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "container p-0" };
const _hoisted_5 = { class: "row ms-2 me-2" };
const _hoisted_6 = {
    key: 1,
    class: "container p-0"
};
const _hoisted_7 = { class: "row ms-2 me-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_product_selector_row = _resolveComponent("g-product-selector-row");
    return (_ctx.product.selectionType === 'variante')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_g_select_field, {
                            "data-member": "currentNumber",
                            "data-mode": "model",
                            label: "Variante",
                            "display-expr": "title",
                            "value-expr": "itemNumber",
                            "data-object": _ctx.$data,
                            "item-source": _ctx.product.variants,
                            "show-clear-button": false
                        }, null, 8, ["data-object", "item-source"])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_g_product_selector_row, {
                            "selector-option": item,
                            selector: _ctx.options,
                            "entry-data": _ctx.entryData
                        }, null, 8, ["selector-option", "selector", "entry-data"])
                    ]));
                }), 256))
            ])
        ], 64))
        : (_ctx.product.selectionType === 'teaser')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_g_product_selector_row, {
                            "selector-option": item,
                            selector: _ctx.options,
                            "entry-data": _ctx.entryData
                        }, null, 8, ["selector-option", "selector", "entry-data"])
                    ]));
                }), 256))
            ]))
            : _createCommentVNode("", true);
}
